import { REAL_ESTATE_SCHEDULE_INTERVALS } from "../../../../services/midpointApi";

export const DATA_SOURCE_SCHEDULE_INTERVALS = REAL_ESTATE_SCHEDULE_INTERVALS;

export const OVERLAY_SCHEDULE_DOMAINS = Object.freeze(["food", "transport", "culture", "finance"]);

export function schedulePayloadFromInterval(minutes, scheduleEnabled) {
  if (!scheduleEnabled || minutes == null) {
    return {
      scheduleEnabled: false,
      scheduleIntervalMinutes: null,
    };
  }

  return {
    scheduleEnabled: true,
    scheduleIntervalMinutes: minutes,
  };
}

export function intervalMinutesFromSource(source) {
  if (!source?.scheduleEnabled) {
    return null;
  }

  return source.scheduleIntervalMinutes ?? null;
}

export function scheduleLabel(source, intervals = DATA_SOURCE_SCHEDULE_INTERVALS) {
  if (!source?.scheduleEnabled || source.scheduleIntervalMinutes == null) {
    return "Manual only";
  }

  const match = intervals.find((item) => item.minutes === source.scheduleIntervalMinutes);
  return match?.label || `Every ${source.scheduleIntervalMinutes} min`;
}

export function overlayScheduleMap(schedules = []) {
  return new Map(
    schedules.map((item) => [`${item.domain}:${item.sourceKey}`, item])
  );
}

export function applyScheduleOverlay(source, overlayByKey, domain) {
  const key = String(source?.sourceKey || source?.sourceCode || "").trim();
  const overlay = overlayByKey?.get(`${domain}:${key}`);
  const next = {
    ...source,
    supportsSchedule: source?.supportsSchedule !== false,
  };

  if (!overlay) {
    if (next.scheduleEnabled == null) {
      next.scheduleEnabled = false;
    }
    return next;
  }

  return {
    ...next,
    supportsSchedule: true,
    scheduleEnabled: overlay.scheduleEnabled,
    scheduleIntervalMinutes: overlay.scheduleIntervalMinutes,
    scheduleCronExpression: overlay.scheduleCronExpression,
    nextRunAt: overlay.nextRunAt || source.nextRunAt || null,
    overlayLastRunAt: overlay.lastRunAt,
    overlayLastStatus: overlay.lastStatus,
    lastErrorMessage: source.lastErrorMessage || overlay.lastErrorMessage || null,
  };
}

export function mergeTransportJobSchedule(source, jobs = []) {
  const sourceCode = String(source?.sourceCode || source?.sourceKey || "").trim();
  const job = (jobs || []).find(
    (item) => String(item.sourceKey || "").trim() === sourceCode
  );
  if (!job) {
    return {
      ...source,
      supportsSchedule: true,
    };
  }

  return {
    ...source,
    supportsSchedule: true,
    supportsRunNow: true,
    transportJobKey: job.jobKey,
    scheduleEnabled: Boolean(job.enabled),
    scheduleIntervalMinutes: job.intervalMinutes ?? null,
    nextRunAt: job.nextRunAt || source.nextRunAt || null,
    lastRunAt: source.lastRunAt || job.lastRunAt || null,
    lastSuccessAt: source.lastSuccessAt || source.lastSuccessfulRunAt || job.lastSuccessAt || null,
    lastErrorMessage: source.lastErrorMessage || job.lastErrorMessage || null,
  };
}
